export default __webpack_public_path__ + "static/media/placeholder_influencer.f66921cb.svg";